var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "232 -824 496 688",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356-260h248v-32H356zm0-144h248v-32H356zm-67.67 268Q264-136 248-152.15t-16-40.47v-574.76q0-24.32 16.15-40.47T288.62-824H596l132 132v499.38q0 24.32-16.16 40.47T671.34-136zM568-664v-128H288.62q-9.24 0-16.93 7.69T264-767.38v574.76q0 9.24 7.69 16.93t16.93 7.69h382.76q9.24 0 16.93-7.69t7.69-16.93V-664zM264-792v149zv624z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.34a051fb5e1496e4c444bbdd3cf852a5.svg";
export { ForwardRef as ReactComponent };